import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { H3 } from '@xo-union/tk-ui-typography';
import { Button } from '@xo-union/tk-component-buttons';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import GdsHouseholdCollection from '~/glm/models/gds/gds-household-collection';
import AnalyticsStore from '~/glm/models/analytics-store';
import styles from './first-time-message.scss';

class EventFirstTimeMessage extends Component {
  goToImportPage = () => {
    const { gdsUiState, analyticsStore, history } = this.props;
    const viewName = gdsUiState.selectedEvent.name;

    gdsUiState.setImportSpreadsheetView(true);
    analyticsStore.track('Dashboard Interaction', {
      action: 'GLM Header Interaction',
      decisionArea: 'start state cta',
      view: viewName,
    });
    history.push('/our-guest-list/import-spreadsheet');
  };

  openGuestModal = () => {
    const { gdsUiState, analyticsStore } = this.props;
    const viewName = gdsUiState.selectedEvent.name;
    gdsUiState.setShowHouseholdForm(true);
    return analyticsStore.track('Dashboard Interaction', {
      action: 'add guest initiated',
      decisionArea: 'start state cta',
      view: viewName,
    });
  };

  render() {
    return (
      <div className={styles.messageContainer}>
        <H3>Add Guests to This Event</H3>
        <p className={styles.subMessage}>
          {"Simply add guests that you've already added to other events, or add a unique guest to this event."}
        </p>
        <Button className={styles.importButton} size="md" onClick={this.goToImportPage}>
          Import Guests
        </Button>
        <Button className={styles.newGuestButton} size="md" onClick={this.openGuestModal}>
          Add Guest
        </Button>
      </div>
    );
  }
}

EventFirstTimeMessage.propTypes = {
  gdsHouseholds: PropTypes.instanceOf(GdsHouseholdCollection),
  gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
  analyticsStore: PropTypes.instanceOf(AnalyticsStore),
};

export default withRouter(EventFirstTimeMessage);
